import { z } from 'zod';
import { paginationQuery } from '../api.js';
/**
 * CRM-Abteilung (Modul `crm`, KON-172, siehe docs/auftragsmanagement.md): der Arbeitsplatz des Vertriebs. Er fasst Anfragen, Angebote, Kontakte und Marketing zusammen und führt
 * Wiedervorlagen, damit kein Angebot und keine Anfrage liegen bleibt. Das Modul hat nur die Tabelle der Wiedervorlagen, alles andere liest es aus den Modulen der Abteilung.
 */
export const FOLLOW_UP_KINDS = ['inquiry', 'offer', 'order', 'contact'];
export const FOLLOW_UP_KIND_LABELS = { inquiry: 'Anfrage', offer: 'Angebot', order: 'Auftrag', contact: 'Kontakt' };
/** Ab so vielen Tagen ohne Antwort gilt ein versendetes Angebot als „zum Nachfassen“ */
export const OFFER_FOLLOW_UP_DAYS = 7;
const optionalNote = z.string().trim().max(1000).optional().transform((v) => (v ? v : undefined));
export const createFollowUpInput = z
    .object({
    subjectKind: z.enum(FOLLOW_UP_KINDS, 'Bitte wählen, wozu die Wiedervorlage gehört'),
    subjectId: z.uuid('Ungültiger Bezug'),
    dueOn: z.iso.date('Bitte ein Datum angeben'),
    note: optionalNote,
    /** Wer nachfasst, ohne Angabe der Anleger */
    assignedUserId: z.uuid('Ungültiger Benutzer').optional(),
})
    .strict();
export const updateFollowUpInput = z
    .object({
    dueOn: z.iso.date('Bitte ein Datum angeben').optional(),
    note: z.string().trim().max(1000).nullable().optional().transform((v) => (v === undefined ? undefined : v ? v : null)),
    assignedUserId: z.uuid('Ungültiger Benutzer').nullable().optional(),
})
    .strict()
    .refine((v) => Object.values(v).some((x) => x !== undefined), 'Keine Änderung angegeben');
export const completeFollowUpInput = z.object({ resultNote: optionalNote }).strict();
export const listFollowUpsQuery = paginationQuery.extend({
    /** open: noch nicht erledigt, due: heute oder früher fällig, done: erledigt */
    scope: z.enum(['open', 'due', 'done']).default('open'),
    subjectKind: z.enum(FOLLOW_UP_KINDS).optional(),
    subjectId: z.uuid().optional(),
    /** Nur die mir zugeteilten */
    mine: z.enum(['1']).optional(),
});
//# sourceMappingURL=crm.js.map